module.exports = __webpack_public_path__ + "static/media/urban-853.198589ae.png";